import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
} from "lucide-react";

export type Side = "top" | "bottom" | "left" | "right";

interface CustomChevronIconProps {
  side?: Side;
  className?: string;
  strokeWidth?: number;
}

const CustomChevronIcon = ({
  side,
  className,
  strokeWidth,
}: CustomChevronIconProps): JSX.Element => {
  switch (side) {
    case "top":
      return (
        <ChevronUp size={24} className={className} strokeWidth={strokeWidth} />
      );
    case "bottom":
      return (
        <ChevronDown
          size={24}
          className={className}
          strokeWidth={strokeWidth}
        />
      );
    case "left":
      return (
        <ChevronLeft
          size={24}
          className={className}
          strokeWidth={strokeWidth}
        />
      );
    case "right":
      return (
        <ChevronRight
          size={24}
          className={className}
          strokeWidth={strokeWidth}
        />
      );
    default:
      return (
        <ChevronDown
          size={24}
          className={className}
          strokeWidth={strokeWidth}
        />
      );
  }
};

export default CustomChevronIcon;
